import React from 'react';
import PropTypes from 'prop-types';
import CommonLinkContainer from 'components/common/link-elements/CommonLinkContainer';
import MenuLinkItemHeaderContent from 'components/dashboard/menu-links-content/MenuLinkItemHeaderContent';
import MenuLinkItemExpandedContent from '../MenuLinkItemExpandedContent';
import { connect } from 'react-redux';
import { deleteMenuLink, patchMenuLink } from 'redux/menu-links/actions';


function MenuLinkItem({ item, patchMenuLink, deleteMenuLink }) {
  
  return (
    <div className="menu-links-list-item-component">
      <CommonLinkContainer
        linkItem={item}
        patchLinkFunction={patchMenuLink}
        allowExpand
        headerContent={
          <MenuLinkItemHeaderContent
            key={`menu-link-item-header-content-key-${item.id}`}
            item={item}
            deleteMenuLink={deleteMenuLink}
          />
        }
        expandedContent={
          <MenuLinkItemExpandedContent
            key={`menu-link-item-expanded-content-key-${item.id}`}
            item={item}
            deleteMenuLink={deleteMenuLink}
          />
        }
      />
    </div>
  );
}

MenuLinkItem.propTypes = {
  item: PropTypes.object.isRequired,
  patchMenuLink: PropTypes.func.isRequired,
  deleteMenuLink: PropTypes.func.isRequired,
}

export default connect(
  null, 
  {
    deleteMenuLink,
    patchMenuLink,
  }
  ) (MenuLinkItem);